import styled from 'styled-components';
import { InputNumber } from 'UI';

type QtySize = 'small' | 'middle' | 'large';

const qtyButtonSizes: Record<QtySize, { width: number; height: number }> = {
  small: { width: 30, height: 28 },
  middle: { width: 40, height: 30 },
  large: { width: 40, height: 30 },
};

const qtyInputSizes: Record<QtySize, { width: number; height: number; margin: number }> = {
  small: { width: 40, height: 24, margin: 4 },
  middle: { width: 80, height: 30, margin: 10 },
  large: { width: 80, height: 30, margin: 10 },
};

export const QtyButton = styled.div<{ disabled?: boolean; $size?: QtySize }>`
  background-color: ${({ theme, disabled }) => (disabled ? theme.color.grey85 : theme.color.grey55)};
  width: ${({ $size = 'middle' }) => `${qtyButtonSizes[$size].width}px`};
  height: ${({ $size = 'middle' }) => `${qtyButtonSizes[$size].height}px`};
  user-select: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  :hover {
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
    filter: ${({ disabled }) => (disabled ? 'none' : 'brightness(0.9)')};
    outline: ${({ theme, disabled }) => (disabled ? 'none' : theme.color.brand + 'solid 1px')};
  }
`;

export const QtyInput = styled(InputNumber)<{ noFixedWidth?: boolean; $size?: QtySize; $extraWidth?: number }>`
  width: ${({ noFixedWidth, $size = 'middle', $extraWidth = 0 }) =>
    noFixedWidth ? undefined : `${qtyInputSizes[$size].width + $extraWidth}px`};
  height: ${({ $size = 'middle' }) => qtyInputSizes[$size].height}px;
  z-index: 50;
  padding: 0 2px 0 2px;
  text-align: center;
  margin-left: ${({ $size = 'middle' }) => qtyInputSizes[$size].margin}px;
`;

// "v2" design: action buttons sit directly against the input as a single connected pill
// (trash/minus as a prefix on the left, plus as a postfix on the right).
export const QtyPillWrapper = styled.div<{ $size?: QtySize }>`
  display: inline-flex;
  align-items: stretch;
  height: ${({ $size = 'middle' }) => qtyButtonSizes[$size].height}px;
  width: fit-content;
`;

export const QtyPillButton = styled.div<{ disabled?: boolean; $size?: QtySize; $position: 'left' | 'right' }>`
  background-color: transparent;
  width: ${({ $size = 'middle' }) => `${qtyButtonSizes[$size].width}px`};
  height: ${({ $size = 'middle' }) => `${qtyButtonSizes[$size].height}px`};
  flex: 0 0 auto;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.color.grey85};
  border-${({ $position }) => ($position === 'left' ? 'right' : 'left')}: none;
  border-radius: ${({ $position }) => ($position === 'left' ? '3px 0 0 3px' : '0 3px 3px 0')};

  :hover {
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
    background-color: ${({ theme, disabled }) => (disabled ? 'transparent' : theme.color.grey85)};
  }
`;

export const QtyInputPill = styled(InputNumber)<{ noFixedWidth?: boolean; $size?: QtySize; $extraWidth?: number }>`
  && {
    min-width: ${({ noFixedWidth, $size = 'middle', $extraWidth = 0 }) =>
      noFixedWidth ? undefined : `${qtyInputSizes[$size].width + $extraWidth}px`};
    height: ${({ $size = 'middle' }) => `${qtyButtonSizes[$size].height}px`} !important;
    text-align: center;
    border-radius: 0;
  }
`;
